// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RoutesFactory } from './router/RoutesFactory';
import { QuoteProvider } from './contexts/quoteContext';
import { QuoteFormSummaryProvider } from './contexts/quoteFormSummaryContext';
import { FileProvider } from './contexts';
import { LanguageProvider } from './contexts/languageContext';
import { useMetadata } from './hooks/useMetadata';
import CongratulationsPage from './pages/congratulationsPage';
import RejectionReminderPage from './pages/rejectionReminderPage';
import SignatureRejectedPage from './pages/signatureRejectedPage';
import SignatureRejectedPageBR from './pages/br/signatureRejectedPage';
import { ClientPortalRoutes } from './clientPortal/ClientPortalRoutes';
import { IntakeDevTools } from './devtools/IntakeDevTools';

import './styles/global.css';

import { REACT_APP_COUNTRY } from './config';
import { GTMProvider } from '@ole/react-library-agents';
import { REACT_APP_GTM_ID } from './config';

const App: React.FC = () => {
  useMetadata();

  return (
    <GTMProvider gtmId={REACT_APP_GTM_ID}>
      <Router>
        <LanguageProvider>
          <Routes>
            {/* Rutas fuera del QuoteProvider para evitar redirecciones por falta de quote */}
            <Route path="/congratulations" element={<CongratulationsPage />} />
            <Route path="/rejection-reminder" element={<RejectionReminderPage />} />
            <Route
              path="/signature-rejected"
              element={REACT_APP_COUNTRY === 'BR' ? <SignatureRejectedPageBR /> : <SignatureRejectedPage />}
            />
            <Route path="/status/*" element={<ClientPortalRoutes />} />
            {/* Resto de rutas dentro del QuoteProvider */}
            <Route path="/*" element={
              <QuoteProvider>
                <QuoteFormSummaryProvider>
                  <FileProvider>
                    <RoutesFactory />
                    {/* Herramientas de desarrollo: apagadas salvo que
                        REACT_APP_INTAKE_DEVTOOLS valga 'true'. Va acá dentro
                        porque necesita el QuoteContext para armar el contexto
                        de intake al iniciar una solicitud. */}
                    <IntakeDevTools mode="application" />
                  </FileProvider>
                </QuoteFormSummaryProvider>
              </QuoteProvider>
            } />
          </Routes>
        </LanguageProvider>
      </Router>
    </GTMProvider>
  );
};

export default App;
